import type { ReactElement } from 'react';
import type { FeatureGateDecision } from '@/hub-shared/gates/featureGateDecisions';

type FeatureGateTooltipProps = {
  decision: FeatureGateDecision;
  children: ReactElement;
};

const FeatureGateTooltip = ({ decision, children }: FeatureGateTooltipProps) => {
  if (decision.allowed || !decision.message) {
    return children;
  }

  return (
    <span className="accounting-hub-gate-tooltip" tabIndex={0}>
      {children}
      <span className="accounting-hub-gate-tooltip__bubble" role="tooltip">
        <span>{decision.message}</span>
        {decision.ctaHref && decision.ctaLabel ? (
          <a href={decision.ctaHref} rel="noopener noreferrer">
            {decision.ctaLabel}
          </a>
        ) : null}
      </span>
    </span>
  );
};

export default FeatureGateTooltip;
